var map = {
	"./bwt/about-banner.jpg": "7b50",
	"./bwt/ai-banner.jpg": "d17a",
	"./bwt/ai1.jpg": "6160",
	"./bwt/banner-index.jpg": "776f",
	"./bwt/base-banner.jpg": "e792",
	"./bwt/base1.jpg": "fae9",
	"./bwt/base2.jpg": "b2fa",
	"./bwt/base3.jpg": "252e",
	"./bwt/base4.jpg": "a035",
	"./bwt/cdp-banner.jpg": "03c5",
	"./bwt/cdp1.jpg": "b954",
	"./bwt/chergpt1.jpg": "f855",
	"./bwt/chergpt2.jpg": "2f18",
	"./bwt/chertgpt-banner.jpg": "d790",
	"./bwt/cloud-banner.png": "84a5",
	"./bwt/cloud1.png": "9fa8",
	"./bwt/device-banner.png": "6e27",
	"./bwt/device1.png": "411f",
	"./bwt/ds1-banner.jpg": "e6f4",
	"./bwt/ds1.jpg": "2d6e",
	"./bwt/ds2-banner.jpg": "925d",
	"./bwt/ds2.jpg": "dfda",
	"./bwt/dscp-banner.jpg": "f7f2",
	"./bwt/dscp1.png": "c981",
	"./bwt/index-card-1.jpg": "48d4",
	"./bwt/index-card-2.jpg": "d62a",
	"./bwt/index-card-3.jpg": "135f",
	"./bwt/index-card-icon-1.png": "f29c",
	"./bwt/index-card-icon-2.png": "2cfb",
	"./bwt/index-card-icon-3.png": "3219",
	"./bwt/index-s1.jpeg": "029f",
	"./bwt/index-s2.png": "57a1",
	"./bwt/index-s3.png": "ef00",
	"./bwt/index-s4.png": "ee67",
	"./bwt/label-bg.jpg": "676b",
	"./bwt/logo.jpg": "f53d",
	"./bwt/logo.png": "d5bc",
	"./bwt/mail-banner.png": "231e",
	"./bwt/mail1.png": "125a",
	"./bwt/rz/1.png": "c127",
	"./bwt/rz/10.png": "2215",
	"./bwt/rz/2.png": "af36",
	"./bwt/rz/3.png": "1a7e",
	"./bwt/rz/4.png": "5844",
	"./bwt/rz/5.png": "4040",
	"./bwt/rz/6.png": "faa3",
	"./bwt/rz/7.png": "f580",
	"./bwt/rz/8.png": "4aa3",
	"./bwt/rz/9.png": "b295",
	"./bwt/s1-1.jpg": "0bc2",
	"./bwt/s1-2.jpg": "96e3",
	"./bwt/s1-3.jpg": "88eb",
	"./bwt/s2-1.jpg": "0b32",
	"./bwt/s2-2.jpg": "5dc3",
	"./bwt/s2-3.jpg": "4b34",
	"./bwt/s2-4.jpg": "8a90",
	"./bwt/s3-1.jpg": "80dc",
	"./bwt/s3-2.png": "3807",
	"./bwt/s3-3.jpg": "3379",
	"./bwt/sbg.jpg": "f555",
	"./bwt/solution1-banner.jpg": "8703",
	"./bwt/solution2-banner.jpg": "aace",
	"./bwt/solution3-banner.jpg": "ebd7",
	"./bwt/zz/cherdrop1.png": "3ebb",
	"./bwt/zz/cherdrop2.png": "f836",
	"./bwt/zz/cloud-iso-cn.png": "287d",
	"./bwt/zz/cloud-iso-en.png": "3883",
	"./bwt/zz/iso14001-cn.png": "e741",
	"./bwt/zz/iso14001-en.png": "924a",
	"./bwt/zz/iso45001-cn.png": "6b5f",
	"./bwt/zz/iso45001-en.png": "5c77",
	"./bwt/zz/iso9001-cn.png": "3e5e",
	"./bwt/zz/iso9001-en.png": "58c2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4940";